import Card from '../../components/ui/Card'
import Badge from '../../components/ui/Badge'
import { formatDate } from '../../lib/format'

function MeetingList({ meetings }) {
  if (!meetings.length) {
    return <div className="text-muted">No meetings logged yet.</div>
  }

  return (
    <div className="stack">
      {meetings.map(meeting => (
        <Card key={meeting.id} className="meeting-card">
          <Card.Header>
            <div>
              <Card.Title>{meeting.title}</Card.Title>
              <div className="text-sm text-muted">{formatDate(meeting.date)} · {meeting.attendees || 'No attendees listed'}</div>
            </div>
            <Badge>{(meeting.decisions || []).length} decisions</Badge>
          </Card.Header>
          <Card.Body>
            {meeting.summary && <p className="mb-4">{meeting.summary}</p>}

            <div className="meeting-grid">
              <div>
                <h4>Decisions</h4>
                <ul className="list-compact">
                  {(meeting.decisions || []).map(decision => (
                    <li key={decision.id}>
                      <strong>{decision.title}</strong> — {decision.decision}
                      {decision.owner && <span className="text-muted"> (Owner: {decision.owner})</span>}
                    </li>
                  ))}
                  {(meeting.decisions || []).length === 0 && <li className="text-muted">No decisions logged</li>}
                </ul>
              </div>
              <div>
                <h4>Action Items</h4>
                <ul className="list-compact">
                  {(meeting.action_items || []).map(item => (
                    <li key={item.id}>
                      {item.description}
                      {item.owner && <span className="text-muted"> — {item.owner}</span>}
                      {item.due_date && <span className="text-muted"> (due {formatDate(item.due_date)})</span>}
                    </li>
                  ))}
                  {(meeting.action_items || []).length === 0 && <li className="text-muted">No action items logged</li>}
                </ul>
              </div>
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  )
}

export default MeetingList
